import { render } from "./WithoutPerson.vue?vue&type=template&id=88303c8c&scoped=true"
import script from "./WithoutPerson.vue?vue&type=script&lang=js"
export * from "./WithoutPerson.vue?vue&type=script&lang=js"

import "./WithoutPerson.vue?vue&type=style&index=0&id=88303c8c&lang=less&scoped=true"
import "./WithoutPerson.vue?vue&type=style&index=1&id=88303c8c&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88303c8c"]])

export default __exports__